import type { ReactElement, ReactNode } from 'react';
import {
  useEffect,
  useRef,
  useState,
  isValidElement,
  cloneElement,
} from 'react';
import styles from '@/styles/documents.module.css';
import { AppConstants } from '@/utils/constants';

export default function DocumentLayout({
  children,
}: {
  children: ReactNode[];
}) {
  const [navWidth, setNavWidth] = useState<number>(
    () =>
      Number(localStorage?.getItem(AppConstants.docResize.key)) ||
      AppConstants.docResize.defaultSize,
  );
  const isResizingRef = useRef<boolean>(false);

  const setNavPaneWidth = (width: number) => {
    setNavWidth(width);
    localStorage.setItem(AppConstants.docResize.key, `${width}`);
  };

  const resize = (e: MouseEvent) => {
    if (isResizingRef.current) {
      const width = e.clientX;
      setNavPaneWidth(width);
    }
  };

  const startResize = () => {
    isResizingRef.current = true;
    document.addEventListener('mousemove', resize as EventListener);
    document.addEventListener('mouseup', stopResize as EventListener);
  };

  const stopResize = () => {
    isResizingRef.current = false;
    document.removeEventListener('mousemove', resize as EventListener);
    document.removeEventListener('mouseup', stopResize as EventListener);
  };

  useEffect(() => {
    return () => {
      document.removeEventListener('mousemove', resize as EventListener);
      document.removeEventListener('mouseup', stopResize as EventListener);
    };
  }, []);

  return (
    <div className={styles?.documents}>
      <div
        className={styles?.sidenavWrapper}
        style={{ width: `${navWidth}px` }}
      >
        {isValidElement(children[0])
          ? cloneElement(children[0] as ReactElement<any>, {
              navWidth: navWidth - 50,
            })
          : null}
      </div>
      <div className={styles?.navBorder} onMouseDown={startResize} />
      <div className={styles?.bodyContainer}>{children[1]}</div>
    </div>
  );
}
